// Configuração central do Cosmos — toda constante "mágica" do engine vive aqui.
// Princípio: ajustar a experiência sem caçar números no código de render.

export const LAYOUT = {
  /** raio do orbital por profundidade (sol→galáxia, galáxia→planeta, ...) */
  ringRadius: [0, 272, 132, 82, 56, 42, 34],
  /** abertura do leque de cada cluster (rad), cresce com nº de filhos */
  fanBase: 0.7,
  fanPerChild: 0.15,
  fanMax: 2.9,
} as const;

export const CAMERA = {
  zoomEase: 0.1,
  panEase: 0.09,
  inertiaFriction: 0.9,
  zoomMin: 0.12,
  zoomMax: 6,
  fitPadding: 1.95,
} as const;

export const MOTION = {
  rotationSpeed: 0.012, // rotação lenta do universo (rad/s)
  driftAmp: 7,
  sunPulseSpeed: 0.5, // pulsação lentíssima do Sol
  focusDimEase: 0.07,
  hoverEase: 0.18,
} as const;

/** Escala solar: tamanho = nível arquitetural (não conexões). */
export const SIZE = {
  council: 156, // ~6x as galáxias
  galaxy: 26,
  byPeso: { 70: 16, 45: 13, 22: 9, 10: 6.5, 5: 5, 2: 3.5 } as Record<number, number>,
  byDepth: { 1: 18, 2: 11, 3: 8, 4: 6, 5: 5 } as Record<number, number>,
} as const;
